import { useGlobalSearchParams } from "expo-router";
import ShiftSurveyScreen from "@/components/screens/ShiftSurveyScreen";

export default function SurveyPage() {
  const { shift } = useGlobalSearchParams<{ shift?: string }>();

  if (!shift) return null;

  return <ShiftSurveyScreen shiftId={shift} />;
}
